import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css'
})
export class CardComponent {
  @Input() iconUrl: string = ''; // Pour l'icône par défaut (URL d'image)
  @Input() hoverIconUrl: string = ''; // Pour l'icône de survol
  @Input() title: string = 'Service';
  @Input() description: string = 'Description du service.';
  @Input() isHovered: boolean = false;
  @Output() cardClick = new EventEmitter<void>(); // Événement pour capturer le clic

  onCardClick() {
    this.cardClick.emit(); // Émettre l'événement quand la carte est cliquée
  }
}
